import { checkIfLoggedIn } from '../actions/auth';

let hash = false;

export const startInterval = () => {
  if (!hash) {
    // Validate session every 5 minutes;
    hash = setInterval(checkIfLoggedIn, 5 * 60 * 1000);
  }
};

export const stopInterval = () => {
  if (hash) {
    clearInterval(hash);
    hash = false;
  }
};
